export const PHYSICAL = "physical";
export const VIRTUAL = "virtual";
